module.exports = __webpack_public_path__ + "img/fira-image-b.da22b4ad.png";